import React, { useState, useRef, useEffect } from "react";
import {
    IconButton, Badge, Tooltip, Popper, Box, Paper, List, ListItem, ListItemText, ClickAwayListener, Divider, Typography, TextField,
    InputAdornment
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmarks";
import { useNavigate } from "react-router-dom";
import { getBasePathBasedOnChartType } from "../../common/utility/helperFunc";
import EditIcon from '@mui/icons-material/EditNote';
import { URL } from "../../common/api/urls";
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth";
import NotificationsIcon from '@mui/icons-material/Notifications';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from "@mui/icons-material/Refresh";
import { NOTIFICATION_POLLING_INTERVAL } from "../../common/utility/constant";



const NotificationComponent = ({ onNoticationClick }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null); // Reference to IconButton
    const [cancel, responseData, error, loaded, reset, executeAPI] = useAxiosWithAuth();
    const [notificationList, setNotificationList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [search, setSearch] = useState('');
    const [hasUnread, setHasUnread] = useState(
        localStorage.getItem('hasUnreadNotifications') === 'true'
    );
   



    useEffect(() => {
        executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
        const handleServiceWorkerMessage = (event) => {
            console.log("FCM Message received from SW:", event);
            //   if (event.data?.type === 'NEW_NOTIFICATION') {
            console.log("FCM service worker Background message received in app", event.data.payload, hasUnread);
            localStorage.setItem('hasUnreadNotifications', 'true');
            setHasUnread(true);
            //   }
        };

        const handleStorageChange = () => {
            setHasUnread(localStorage.getItem('hasUnreadNotifications') === 'true');
        };


        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
        }

        window.addEventListener('storage', handleStorageChange);
        // Cleanup function to remove the event listener
        return () => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
            }
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    //polling notifications
    useEffect(()=>{
        if(open)
            executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
        
        const refreshInterval = setInterval(() => {
           
            if(open){
                console.log("Calling polling notigication api")
                executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
            }            
        
        }, NOTIFICATION_POLLING_INTERVAL);
        return () => {
            clearInterval(refreshInterval);
          };
    },[open]);


    useEffect(() => {
        console.log("FCM hasunread=", hasUnread)
        if (hasUnread)
            executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
    }, [hasUnread]);



    //api response handler
    useEffect(() => {
        if (loaded) {
            // console.log("Bookmark list ========>",responseData.data);
            if (responseData != null) {
                let data = responseData.data ? responseData.data : [];
                setNotificationList(data);
                if (search) {
                    let temp = data.filter(item =>
                        item.toLowerCase().includes(search)

                    );
                    setFilteredList(temp);

                } else {
                    setFilteredList(data)
                }


            } else if (error !== null) {
                console.log("Error data=", error);
                // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    console.log("status received =", error?.response?.status)
                    //   navigate(from, { replace: true });
                } else {
                    //   setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
                }
            }
            reset();

        }

    }, [loaded, responseData])

    const handleToggle = () => {
        setSearch('');
        setOpen(true);
        // setOpen((prev) => !prev);
        localStorage.setItem('hasUnreadNotifications', 'false');
        setHasUnread(false);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };



    const openNotification = (event, item) => {
        // setOpen(false);

    }
    const handleSearchChange = (e) => {

        setSearch(e.target.value.toLowerCase());


    };

    useEffect(() => {
        console.log("search= 1", search)
        if (search) {
            let temp = notificationList.filter(item =>
                item.toLowerCase().includes(search)

            );
            setFilteredList(temp);
            console.log("search= 2 ", search, temp)
        } else {
            setFilteredList(notificationList)
        }
    }, [search])

    const handleRefresh = () => {
        executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
    };

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                sx={{ mr: 1 }}
                size="small"
                edge="start"
                aria-label="bookmark"
            >
                <Tooltip title="Notification">
                    {/* <NotificationsIcon sx={{ color: "primaryTheme.shade01", width: "24px", height: "24px" }} /> */}
                    <Badge
                        color="warning"
                        variant="dot"
                        invisible={!hasUnread} // dynamically toggle this
                        sx={{
                            "& .MuiBadge-dot": {
                                backgroundColor: "#FF5733", // Custom color
                            },
                        }}
                    >
                        <NotificationsIcon
                            sx={{ color: "primaryTheme.shade01", width: "24px", height: "24px" }}
                        />
                    </Badge>
                </Tooltip>
            </IconButton>

            {/* Popper for showing the list below the button */}
            {/* <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" style={{ zIndex: 1300,mr:-8 }}> */}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-end"
                style={{ zIndex: 1300, transform: "translateX(-20px)" }} // Moves it 20px left
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                        elevation={3}
                        sx={{
                            pl: 1,
                            pr: 1,
                            pb: 1,
                            // width:400,
                            minWidth: 420,
                            maxWidth: 500,
                            maxHeight: 500,  // Limit height to 400px
                            overflowY: "auto" // Enable scrolling when content overflows
                        }}
                    >
                      
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mt: 1,
                                mb: 1
                            }}
                        >
                            <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Search notifications"
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <SearchIcon fontSize="small" sx={{ mr: 1, ml: 1 }} />
                                    )
                                }}
                            />
                            <IconButton onClick={handleRefresh} sx={{ ml: 1 }}>
                                <RefreshIcon />
                            </IconButton>
                        </Box>
                        <List>

                            {/* <Divider /> Adds a separator */}
                            {filteredList.length > 0 ? (
                                filteredList.map((item) => (
                                    <ListItem button key={item} onClick={(event) => openNotification(event, item)}>
                                        <ListItemText primary={
                                            <Typography variant="body2" sx={{ fontSize: "12px" }}>
                                                {item}
                                            </Typography>
                                        } />
                                    </ListItem>
                                ))
                            )
                                : (
                                    <></>
                                    // <ListItem>
                                    //     {/* <ListItemText primary="No notification available" /> */}
                                    // </ListItem>
                                )
                            }
                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default NotificationComponent;
